<div class="start-text-holder">
  <h3>Rubrik</h3>
  <div>Nedanstående är en iframe</div>
</div>